const USE_CHAT_REQUEST = "cf_agent_use_chat_request";
const USE_CHAT_RESPONSE = "cf_agent_use_chat_response";
const CHAT_REQUEST_CANCEL = "cf_agent_chat_request_cancel";
export class WebSocketChatTransport {
  constructor(connection) {
    this.connection = connection;
  }
  sendMessages(options) {
    const { connection } = this;
    const { messages, abortSignal, trigger, messageId, chatId, body } = options;
    const requestId = crypto.randomUUID();
    const stream = new ReadableStream({
      start(controller) {
        const cleanup = () => {
          connection.removeEventListener("message", onMessage);
          connection.removeEventListener("close", onSocketClosed);
          connection.removeEventListener("error", onSocketClosed);
          abortSignal?.removeEventListener("abort", onAbort);
        };
        const onSocketClosed = () => {
          cleanup();
          controller.error(new Error("agent connection closed mid-stream"));
        };
        const onMessage = (event) => {
          const { data } = event;
          if (typeof data !== "string") return;
          let parsed;
          try {
            parsed = JSON.parse(data);
          } catch {
            return;
          }
          if (parsed === null || typeof parsed !== "object") return;
          const frame = parsed;
          if (frame.type !== USE_CHAT_RESPONSE || frame.id !== requestId) return;
          if (frame.error === true) {
            cleanup();
            controller.error(
              new Error(
                typeof frame.body === "string" ? frame.body : "chat stream error"
              )
            );
            return;
          }
          if (typeof frame.body === "string") {
            try {
              controller.enqueue(JSON.parse(frame.body));
            } catch {
            }
          }
          if (frame.done) {
            cleanup();
            controller.close();
          }
        };
        const onAbort = () => {
          try {
            connection.send(
              JSON.stringify({ type: CHAT_REQUEST_CANCEL, id: requestId })
            );
          } finally {
            cleanup();
            controller.close();
          }
        };
        if (abortSignal?.aborted) {
          controller.close();
          return;
        }
        connection.addEventListener("message", onMessage);
        connection.addEventListener("close", onSocketClosed);
        connection.addEventListener("error", onSocketClosed);
        abortSignal?.addEventListener("abort", onAbort);
        try {
          connection.send(
            JSON.stringify({
              type: USE_CHAT_REQUEST,
              id: requestId,
              init: {
                method: "POST",
                body: JSON.stringify({
                  id: chatId,
                  messages,
                  trigger,
                  messageId,
                  ...body
                })
              }
            })
          );
        } catch (e) {
          cleanup();
          controller.error(e);
        }
      }
    });
    return Promise.resolve(stream);
  }
  /** Stream resume is not implemented for the POC; turns start fresh. */
  reconnectToStream() {
    return Promise.resolve(null);
  }
}
